import React from "react";
import "../../styles/components/selectProgress/SelectProgress.scss";

export default function SelectProgress({ value }) {
  return (
    <div className="select-progress">
      <progress value={value} max="100" />
      <p>{value}%</p>
      <figure>
        <img src="/images/makingBranch/progress-book.svg" alt="progress" />
      </figure>
    </div>
  );
}
